import React from 'react';

import { Icon } from '@rbilabs/universal-components';

import { ActionButtonVariants } from 'components/action-button';
import { CustomEventNames, EventTypes } from 'state/mParticle/constants';
import { theme } from 'styles/configure-theme';

import { StyledRedemptionButton } from './redemption-button.styled';
import { IRedemptionButton } from './types';

export const RedemptionButton: React.FC<React.PropsWithChildren<IRedemptionButton>> = ({
  onPressRestaurantRedemption,
  restaurantRedemptionButtonTitle,
  disabled,
}) => {
  return (
    <>
      <StyledRedemptionButton
        testID="restaurant-redemption-button"
        onPress={onPressRestaurantRedemption}
        eventName={CustomEventNames.OFFER_CODE_REQUESTED}
        eventType={EventTypes.Other}
        disabled={disabled}
        startIcon={
          <Icon variant="store" color={theme.token('icon-default')} width="20px" aria-hidden />
        }
        variant={ActionButtonVariants.OUTLINE}
      >
        {restaurantRedemptionButtonTitle}
      </StyledRedemptionButton>
    </>
  );
};
